export default "__VITE_ASSET__CZsvJ23V__"